// =============================================================================
// SHARE BUTTON - Tactical styled share trigger button
// =============================================================================

import { motion } from 'framer-motion';

interface ShareButtonProps {
    onClick: () => void;
    variant?: 'primary' | 'secondary' | 'danger';
    className?: string;
}

export function ShareButton({ onClick, variant = 'primary', className = '' }: ShareButtonProps) {
    const colorMap = {
        primary: {
            border: 'border-war-primary',
            text: 'text-war-primary',
            bg: 'bg-war-primary/10 hover:bg-war-primary/20',
        },
        secondary: {
            border: 'border-war-dim/40',
            text: 'text-war-dim',
            bg: 'bg-war-panel hover:bg-war-dim/10',
        },
        danger: {
            border: 'border-war-red',
            text: 'text-war-red',
            bg: 'bg-war-red/10 hover:bg-war-red/20',
        },
    };

    const colors = colorMap[variant];

    return (
        <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onClick}
            className={`
        group relative border ${colors.border} ${colors.bg} 
        transition-all py-3 px-6 font-mono ${className}
      `}
        >
            <span className={`${colors.text} text-xs font-bold tracking-widest uppercase flex items-center gap-2 justify-center`}>
                <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                    />
                </svg>
                Поділитися
            </span>
            {/* Corner accents */}
            <div className={`absolute top-0 left-0 w-2 h-2 border-t border-l ${colors.border}`} />
            <div className={`absolute top-0 right-0 w-2 h-2 border-t border-r ${colors.border}`} />
            <div className={`absolute bottom-0 left-0 w-2 h-2 border-b border-l ${colors.border}`} />
            <div className={`absolute bottom-0 right-0 w-2 h-2 border-b border-r ${colors.border}`} />
        </motion.button>
    );
}
